import { render, staticRenderFns } from "./OnboardingTokenInfo.vue?vue&type=template&id=2dbde546&scoped=true&lang=pug"
import script from "./OnboardingTokenInfo.vue?vue&type=script&lang=ts"
export * from "./OnboardingTokenInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbde546",
  null
  
)

export default component.exports